import css from 'styled-jsx/css'
import { colors } from '../../styles'
import { transparentize } from '../../utils/colors'

export default css`
.ScheduleCard {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100vw;
  max-height: auto;
  border-radius: 16px !important;
  background: #1F1F1F;
  overflow: hidden;
}
span{
font-family: Source Sans Pro;
font-size: 18px;
font-weight: 600;
line-height: 22.63px;
text-align: left;
color: #FFFF00;
}
.ScheduleCard.overlay{
  width: 292px;
    max-width: 292px;
    max-height: 225px;
    flex-basis: unset;
    flex-grow: unset;
    border: 1px solid rgba(246, 246, 246, 0.10);
    background: #151515;
    border-radius: 8px !important;
    margin: 0px !important;
}
.ps-overlay{
    position: absolute;
    top: 0px;
    left: 0px;
    padding: 16px;
    width: 100%;
    display: flex;
    gap: 8px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.70) 21.95%, rgba(0, 0, 0, 0.00) 100%);
    flex-direction: row;
    align-items: center;
    z-index: 2;
}

.ScheduleCard.tv-guide{
  width: 316px;
  max-width: 316px;
  max-height: 302px;
  flex-basis: unset;
  flex-grow: unset;
  border: 1px solid rgba(246, 246, 246, 0.10);
  background: #151515;
  border-radius: 8px !important;
  margin: 0px !important;
}
.ScheduleCard:hover{
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.50);
}
.progress-bar {
  left: 7px;
  bottom: 4px;
  width: 93%;
  position: absolute;
  height: 4px;
  flex-shrink: 0;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.30)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.15));
}
figure {
  position: relative;
  overflow: hidden;
}
figcaption{
  position: relative;
  top: -40px;
  height: 40px;
  background: linear-gradient(360deg, rgba(0, 0, 0, 0.70) 21.95%, rgba(0, 0, 0, 0.00) 100%);
}
figcaption.overlay{
  top: -25px;
  height: 25px;
}
.progress-bar.live {
  bottom: 53px;
  left: 24px;
  right: 24px;
  width: auto;
}
.progress-bar.live.overlay {
  bottom: 32px;
  left: 16px;
  right: 16px;
  width: auto;
}
.figure-wrapper {
  border-radius: 16px !important;
  margin: 0;
}
.figure-wrapper.overlay {
  border-radius: 8px !important;
  margin: 0;
}
figure .live-gradient{
  z-index: 1;
  position: relative;
  top: 0;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  color: ${transparentize(colors.primaryText, 0.8)};
  height: 100%;
  background-origin: border-box;
}


.time-left{
  position: relative;
  width: auto;
  padding: 4px 24px 4px 4px;
  top: -4px;
  height: 20px;
  border-radius: 2px;
  gap: 8px;
  font-family: Source Sans Pro;
  font-size: 16px;
  font-weight: 600;
  line-height: 10px;
  -webkit-letter-spacing: 0px;
  -moz-letter-spacing: 0px;
  -ms-letter-spacing: 0px;
  letter-spacing: 0px;
  text-align: right;
  margin-top: -15px;
}
.time-left.overlay{
  top: -6px;
  padding: 4px 16px 4px 4px;
  font-size: 12px
}
.live-player {
  color: ${colors.primaryText};
  display: flex;
  width: 50px;
  position: relative;
  background: ${colors.liveRed};
  top: -4px;
  left: 24px;
  bottom: unset;
  border-radius: 2px;
  padding: 2px 4px 2px 4px;
}
.live-player.overlay{
  top: -6px;
  left 16px;
}
.live-player p.live-subtitle {
  padding-left: 4px;
  display: inline-block;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.6px;
  text-transform: uppercase;
}
  
.bottom-data {
  display: flex;
  align-items: center;
}

.bottom-wrapper {
  display: flex;
  position: relative;
  top: -20px;
  flex-direction: row;
  padding: 0px 16px 8px 16px;
}
.bottom-wrapper.overlay{
  padding: 5px 8px 5px 8px;
  gap: 8px;

  top: -22px;
}

.bottom-wrapper .bottom-image {
  display: flex;
  align-items: center;
}

.tv-guide .bottom-wrapper .bottom-image {
  align-items: flex-start;
  padding-top: 4px;
}

.image-wrapper{
  transition: transform .2s ease;
  transform-origin: 50% 50%;
  background-image: linear-gradient(0deg, rgba(0.13,0.13,0.13,0.7) 100%, transparent);
}

.schedule {
display: none;
}

.pre-title {
  font-size: 24px;
  line-height: 1;
  color: #fff;
  font-weight: bold;
  display: inline-block;
  padding: 10px 20px;
  text-transform: uppercase;
}

.title {
  color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
  font-family: "Source Sans Pro";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  width: auto;
  line-height: normal;
}
.title.overlay {
width: 220px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
font-size: 18px;
}

.summary {
  color: var(--white-01-f-6-f-6-f-6, #F6F6F6);
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.main-content {
display: flex;
flex-direction: column;
gap: 8px;
}
.main-content.overlay{
gap:4px;
}

.time {
  color: var(--white-02-c-4-c-4-c-4, #C4C4C4);
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.time.overlay {
    font-size: 14px;
    }

.more-episodes {
  color: ${colors.darkPurple};
  font-weight: bold;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-top: 42px;
}
@media (max-width: 767px) {
.ScheduleCard.tv-guide{
  width: 100%;
  max-width: 100%;
  max-height: 350px;
}
}
@media (min-width: 1024px) {
  .ScheduleCard {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 564px;
    max-height: 470px;
    border-radius: 16px !important;
    background: #1F1F1F;
  }
  .title {
    font-size: 24px;
  }
  .time {
    font-size: 18px;
  }
  figure.schedule {
    display: block;
    margin: 0;
    flex: none;
    border-radius: 50px;
  }
  figure.schedule:global(.Image) {
    width: 33px;
    height: 34px;
    flex-shrink: 0;
  }
  figure.schedule.overlay
  :global(.Image) {
    width: 41px;
    height: 41px;
    flex-shrink: 0;
  }
  .ScheduleCard:first-child {
    margin-left: 20px !important;
    margin-right: 8px;
  }
  .ScheduleCard.tv-guide:first-child{
    margin-left: 0px !important;
  }
  .bottom-wrapper{
  padding: 0px 24px 0px 24px;
  }
  .ScheduleCard:last-child {
    margin-left: 8px;
  }
}
`
